import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useScript } from '@bluheadless/ui-logic/src/hooks/use-script/useScript'
import { string, number, bool, oneOf } from 'prop-types'
import { Root } from './widget.styled'

const Widget = ({
	purchaseAmount,
	alignment,
	size,
	logoSize,
	logoAlignment,
	logoColor,
	priceColor,
	hideLogo,
	hidePrice,
	...props
}) => {
	const {
		locale,
		sales: {
			payments: {
				scalapay: { enabled, scriptUrl, min, max, installments },
			},
		},
	} = useConfig()

	const status = useScript({
		src: enabled ? scriptUrl : null,
	})

	return status === 'ready' ? (
		<Root className="ScalapayWidget-root" {...props}>
			<scalapay-widget
				amount={purchaseAmount}
				locale={locale.split('-')[0]}
				min={min}
				max={max}
				alignment={alignment}
				size={size}
				logoSize={logoSize}
				logoAlignment={logoAlignment}
				logoColor={logoColor}
				priceColor={priceColor}
				hideLogo={hideLogo}
				hidePrice={hidePrice}
				numberOfPayments={installments}
			></scalapay-widget>
		</Root>
	) : null
}

Widget.defaultProps = {
	alignment: 'center',
}

Widget.propTypes = {
	purchaseAmount: number,
	alignment: oneOf(['left', 'center', 'right']),
	size: string,
	logoSize: string,
	logoAlignment: number,
	logoColor: string.isRequired,
	priceColor: string.isRequired,
	hideLogo: bool,
	hidePrice: bool,
}

export default Widget
